module.exports = __webpack_public_path__ + "static/img/saas_banner_bg.941d914.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/saas_banner_bg.jpg
// module id = uS64
// module chunks = 14